import React from 'react'
import { tv } from 'tailwind-variants';
import cn from 'classnames'

const LanguageButton = ({ children, size, outlined = false, onClick }) => {

  return (
    <button
      onClick={onClick}
      className={cn(
        button({ size: size, color: outlined ? 'outlined' : 'filled' })
      )}
    >
      {children}
    </button>
  )
}

export default LanguageButton;

const button = tv({
  base: "flex justify-center items-center font-normal focus:outline-none rounded-full",
  variants: {
    color: {
      filled: 'bg-gradient-to-r from-lightBlue to-darkBlue text-white border-secondary',
      outlined: 'border-2 border-primary text-primary dark:text-white',
    },
    size: {
      'sm': 'text-base p-2',
      'md': 'text-base p-2',
      'lg': 'text-lg p-3',
      'xl': 'text-xl p-3',
      '2xl': 'text-2xl p-4',
      '3xl': 'text-4xl p-5',
      '4xl': 'text-2xl h-16 w-16',
      '5xl': 'text-5xl p-5',
      '6xl': 'text-6xl p-6',
      '7xl': 'text-7xl p-6',
    }
  },
  defaultVariants: {
    size: "4xl",
    color: "dark",
  }
});